import { useState } from "react";
import { Clock, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import StepShell from "../StepShell";
import * as api from "../briefingService";

const PROVIDERS = {
  asaas: {
    title: "Conecte o Asaas",
    description:
      "Cole o token de API do Asaas. A cobrança automática é ativada assim que o WhatsApp entrar no ar.",
    inputLabel: "Token de API do Asaas",
    placeholder: "Cole o token do Asaas",
  },
  zapsign: {
    title: "Conecte a ZapSign",
    description:
      "Cole o token de API da ZapSign. O envio de contratos é ativado assim que o WhatsApp entrar no ar.",
    inputLabel: "Token de API da ZapSign",
    placeholder: "Cole o token da ZapSign",
  },
};

/**
 * TokenStep — generic third-party token screen (Asaas/ZapSign). Uses the
 * dedicated integrations route (server-side merge) so the encrypted
 * pendingToken parked for the WhatsApp gating listener is never overwritten.
 */
export default function TokenStep({ provider, clientId, briefing }) {
  const meta = PROVIDERS[provider];
  const ic = briefing.integrationsConfig || {};
  const [token, setToken] = useState("");
  const [pending, setPending] = useState(!!ic[provider]?.hasPendingToken);
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  async function saveToken() {
    if (!token.trim()) return;
    setSaving(true);
    setErrorMsg("");
    try {
      await api.saveIntegrations(clientId, { tokens: { [provider]: token.trim() } });
      setToken("");
      setPending(true);
    } catch (err) {
      setErrorMsg(err.message || "Falha ao salvar o token.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <StepShell title={meta.title} description={meta.description}>
      <div className="max-w-md space-y-2 rounded-xl border border-border bg-surface-inset/40 p-4">
        {pending ? (
          <p className="flex items-center gap-2 text-sm text-amber-600 dark:text-amber-400">
            <Clock className="h-4 w-4" /> Token salvo — será ativado quando o WhatsApp
            entrar no ar.
          </p>
        ) : (
          <>
            <Label htmlFor={`${provider}-token`}>{meta.inputLabel}</Label>
            <div className="flex gap-2">
              <Input
                id={`${provider}-token`}
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder={meta.placeholder}
                autoComplete="off"
              />
              <Button onClick={saveToken} disabled={saving || !token.trim()}>
                {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar"}
              </Button>
            </div>
            <p className="text-xs text-muted-foreground">
              Guardamos o token de forma segura; a configuração roda sozinha após o
              WhatsApp ativo. Você pode pular e enviar depois.
            </p>
          </>
        )}
        {errorMsg && <p className="text-sm text-destructive">{errorMsg}</p>}
      </div>
    </StepShell>
  );
}
